import axios from 'axios';

import {
  axiosHeaderV2,
  getV2RootUrl,
  publicAxiosHeaderV2
} from 'common/helpers/apiHelper';

export const listOrders = (customerId, queryString) => {
  if (queryString) {
    return axios.get(
      `${getV2RootUrl()}/customer/${customerId}/order?${queryString}`,
      axiosHeaderV2()
    );
  }
  return axios.get(
    `${getV2RootUrl()}/customer/${customerId}/order`,
    axiosHeaderV2()
  );
};

export const getOrder = (orderId) =>
  axios.get(
    `${getV2RootUrl()}/order/${orderId}/limited`,
    publicAxiosHeaderV2()
  );

export const getCustomerOrder = (customerId, orderId) =>
  axios.get(
    `${getV2RootUrl()}/customer/${customerId}/order/${orderId}`,
    publicAxiosHeaderV2()
  );
